import { render, staticRenderFns } from "./ProfitReports.vue?vue&type=template&id=bf357dbe"
import script from "./ProfitReports.vue?vue&type=script&lang=js"
export * from "./ProfitReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports